export const brandCategories = [
  {
    slug: 'ruoruo-series',
    name: '若若系列',
    description: '以温润滋养为核心，精选天然植萃成分，为肌肤注入如幼水般的柔润力量。',
    products: [
      {
        id: 'rr-001',
        name: '若若柔肤精华水',
        tagline: '如晨露轻抚，唤醒肌肤原生柔润',
        description: '蕴含玫瑰纯露与玻尿酸，轻盈水润质地，深入肌底补水，令肌肤柔嫩如初。',
        image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20skincare%20product%20photography%2C%20a%20clear%20glass%20bottle%20of%20facial%20toner%20with%20soft%20pink%20liquid%20inside%2C%20placed%20on%20a%20warm%20cream%20textured%20surface%20with%20delicate%20rose%20petals%20scattered%20around%2C%20soft%20natural%20lighting%20from%20left%20side%2C%20dreamy%20and%20elegant%20atmosphere%2C%20editorial%20quality%20with%20shallow%20depth%20of%20field&width=600&height=600&seq=rr-001&orientation=squarish',
        features: ['玫瑰纯露精华', '玻尿酸补水', '无酒精配方', '适合所有肤质'],
      },
      {
        id: 'rr-002',
        name: '若若润养面霜',
        tagline: '一抹即化的丝绒触感，锁住水润一整天',
        description: '融合乳木果油与神经酰胺，丰润质地如丝绸般贴合肌肤，深层滋养修护肌肤屏障。',
        image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20face%20cream%20in%20a%20matte%20white%20jar%20with%20wooden%20lid%2C%20set%20on%20a%20warm%20beige%20linen%20cloth%2C%20a%20small%20wooden%20spatula%20beside%20it%2C%20soft%20diffused%20morning%20light%2C%20minimalist%20and%20elegant%20composition%2C%20clean%20aesthetic%20product%20photography&width=600&height=600&seq=rr-002&orientation=squarish',
        features: ['乳木果油滋养', '神经酰胺修护', '丝绒质地', '干燥肌友好'],
      },
      {
        id: 'rr-003',
        name: '若若氨基酸洁面乳',
        tagline: '温和洁净不紧绷，洗出婴儿般柔嫩肌',
        description: '氨基酸表活配方，细腻绵密泡沫轻柔清洁毛孔，洗后肌肤水润不紧绷。',
        image: 'https://readdy.ai/api/search-image?query=A%20gentle%20facial%20cleanser%20in%20a%20minimalist%20pump%20bottle%20with%20soft%20cream%20color%2C%20placed%20on%20a%20wet%20marble%20surface%20with%20water%20droplets%2C%20a%20few%20white%20flowers%20in%20the%20background%2C%20fresh%20and%20clean%20aesthetic%2C%20bright%20natural%20lighting%2C%20high-end%20skincare%20photography&width=600&height=600&seq=rr-003&orientation=squarish',
        features: ['氨基酸表活', '温和不刺激', '绵密泡沫', '敏感肌适用'],
      },
      {
        id: 'rr-004',
        name: '若若保湿面膜',
        tagline: '一片浸润水润能量，敷出水光婴儿肌',
        description: '超薄蚕丝膜布承载满满精华液，密集补水修护，让肌肤喝饱水。',
        image: 'https://readdy.ai/api/search-image?query=A%20sheet%20mask%20product%20photography%2C%20a%20white%20and%20soft%20pink%20face%20mask%20packet%20on%20a%20bamboo%20tray%20with%20water%20droplets%2C%20surrounded%20by%20fresh%20green%20leaves%20and%20a%20small%20vial%20of%20serum%2C%20spa-like%20atmosphere%2C%20soft%20diffused%20lighting%2C%20clean%20and%20refreshing%20aesthetic&width=600&height=600&seq=rr-004&orientation=squarish',
        features: ['蚕丝膜布', '密集补水', '舒缓修护', '单片独立包装'],
      },
    ],
  },
  {
    slug: 'youshui-series',
    name: '幼水系列',
    description: '以轻盈水润为主调，探索水与肌肤的和谐共鸣，带来如泉水般的清新体验。',
    products: [
      {
        id: 'ys-001',
        name: '幼水轻盈防晒乳',
        tagline: '轻薄如水，隐形防护无负担',
        description: 'SPF50+ PA++++ 高倍防晒，水感质地一秒化水，清爽不黏腻，自然提亮肤色。',
        image: 'https://readdy.ai/api/search-image?query=A%20sunscreen%20product%20in%20a%20sleek%20white%20tube%20with%20minimalist%20design%2C%20placed%20on%20a%20light%20wooden%20surface%20near%20a%20window%20with%20soft%20sunlight%20streaming%20in%2C%20a%20small%20green%20plant%20in%20the%20corner%2C%20fresh%20and%20airy%20atmosphere%2C%20clean%20beauty%20photography&width=600&height=600&seq=ys-001&orientation=squarish',
        features: ['SPF50+ PA++++', '水感质地', '清爽不黏腻', '自然提亮'],
      },
      {
        id: 'ys-002',
        name: '幼水清透卸妆油',
        tagline: '以油溶妆，遇水即化，零残留清透洁净',
        description: '天然植物油基底，轻轻按摩即可溶解顽固彩妆，遇水乳化彻底，洗后不油腻。',
        image: 'https://readdy.ai/api/search-image?query=A%20cleansing%20oil%20in%20a%20transparent%20glass%20bottle%20showing%20the%20golden%20oil%20inside%2C%20placed%20on%20a%20white%20marble%20surface%2C%20a%20cotton%20pad%20and%20a%20small%20bottle%20of%20flowers%20nearby%2C%20warm%20and%20elegant%20lighting%2C%20luxury%20skincare%20product%20photography&width=600&height=600&seq=ys-002&orientation=squarish',
        features: ['天然植物油', '遇水乳化', '深层清洁', '不闷痘配方'],
      },
      {
        id: 'ys-003',
        name: '幼水舒缓喷雾',
        tagline: '随时随地，为肌肤降一场温柔细雨',
        description: '蕴含温泉矿物与洋甘菊精华，细腻雾化喷头，瞬间舒缓干燥不适，定妆补水两相宜。',
        image: 'https://readdy.ai/api/search-image?query=A%20facial%20mist%20spray%20in%20a%20sleek%20frosted%20glass%20bottle%2C%20being%20sprayed%20with%20fine%20mist%20droplets%20visible%20in%20the%20air%2C%20set%20against%20a%20soft%20green%20botanical%20background%2C%20fresh%20and%20revitalizing%20atmosphere%2C%20natural%20light%2C%20spa-inspired%20photography&width=600&height=600&seq=ys-003&orientation=squarish',
        features: ['温泉矿物', '洋甘菊舒缓', '微米级雾化', '定妆补水'],
      },
      {
        id: 'ys-004',
        name: '幼水修护精华液',
        tagline: '一滴修护，重现水润光泽肌',
        description: '高浓度玻尿酸与烟酰胺复配，轻盈精华质地快速吸收，提升肌肤水润度与光泽感。',
        image: 'https://readdy.ai/api/search-image?query=A%20serum%20bottle%20with%20dropper%2C%20minimalist%20design%20in%20soft%20amber%20glass%2C%20placed%20on%20a%20cream%20textured%20surface%2C%20a%20drop%20of%20serum%20on%20a%20glass%20rod%2C%20soft%20warm%20lighting%2C%20elegant%20and%20scientific%20aesthetic%2C%20high-end%20skincare%20product%20photography&width=600&height=600&seq=ys-004&orientation=squarish',
        features: ['高浓度玻尿酸', '烟酰胺复配', '快速吸收', '提亮光泽'],
      },
    ],
  },
  {
    slug: 'limited-collection',
    name: '限定系列',
    description: '季节限定与联名合作款，以独特的灵感诠释幼水若若的生活美学。',
    products: [
      {
        id: 'lc-001',
        name: '春樱限定柔肤礼盒',
        tagline: '樱花季节的温柔馈赠，一套尽享柔润呵护',
        description: '含柔肤精华水+润养面霜旅行装，春日樱花限定包装，是馈赠亲友的温暖心意。',
        image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20skincare%20gift%20set%20in%20a%20soft%20pink%20box%20with%20cherry%20blossom%20motif%2C%20opened%20to%20reveal%20mini%20bottles%20inside%2C%20set%20on%20a%20light%20wooden%20table%20with%20cherry%20blossom%20branches%2C%20spring%20atmosphere%2C%20soft%20pastel%20aesthetic%2C%20gift-worthy%20presentation&width=600&height=600&seq=lc-001&orientation=squarish',
        features: ['含柔肤精华水', '含润养面霜', '樱花限定包装', '送礼佳品'],
      },
      {
        id: 'lc-002',
        name: '夏荷清透体验套装',
        tagline: '夏日荷风，带来一季的清爽水润',
        description: '清透卸妆油+舒缓喷雾，夏季出行必备组合，轻盈便携，随时补充水润能量。',
        image: 'https://readdy.ai/api/search-image?query=A%20summer%20skincare%20travel%20set%20in%20a%20natural%20linen%20pouch%2C%20containing%20small%20bottles%20and%20a%20facial%20mist%2C%20placed%20on%20a%20beach%20towel%20with%20a%20lotus%20flower%20and%20green%20leaves%2C%20bright%20summer%20sunlight%2C%20fresh%20and%20breezy%20vibe&width=600&height=600&seq=lc-002&orientation=squarish',
        features: ['含清透卸妆油', '含舒缓喷雾', '夏日便携', '旅行套装'],
      },
    ],
  },
];

export const allProducts = brandCategories.flatMap(cat => cat.products);